<template>
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: center">
        <div class="dev-list">
            <div class="dev-list-search">
                <div class="search-btn">
                    <div class="search-btn-pre">
                        <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;margin-right: 20px;">
                            <span style="font-size: 14px; margin-right: 10px;">故障时间筛选</span>
                            <el-date-picker
                                    v-model="dateValue"
                                    type="daterange"
                                    size="small"
                                    :picker-options="pickerOptions"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @change="getFaultDeviceListForSearch"
                            >
                            </el-date-picker>
                        </div>
                        <el-button type="primary" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>
                        <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                                   @click="rebootDevCross" v-if="$store.getters.checkChangeAuth()">跨板重启
                        </el-button>
                        <el-button type="primary"
                                   :disabled="multipleSelection.length === 0 || devicePingPopShow == true"
                                   size="small" @click="startDevicePing">连通性测试
                        </el-button>
                    </div>
                    <!--<el-button type="text" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>-->
                </div>
                <div class="search-advanced" v-show="advancedShow" @keyup.enter="getFaultDeviceListForSearch">
                    <div class="search-main">
                        <div class="search-main-item">
                            <span>选择分组:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.groupId" size="mini" placeholder="分组">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="search-main-item">
                            <span>选择引擎版本:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.engineType" size="mini" placeholder="引擎版本">
                                    <el-option
                                            v-for="item in searchOptions.version"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备池编号:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.caseNo" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备IP:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.deviceIp" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备编号:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.deviceNo" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备ID:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.id" size="mini"></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="search-btn">
                        <el-button type="primary" size="mini" @click="getFaultDeviceListForSearch">搜索</el-button>
                        <el-button size="mini" @click="advancedShow = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="cleanSearchInfo">重置搜索条件</el-button>
                    </div>
                </div>
            </div>
            <div class="device-case-dev border-all" >
                <el-table ref="multipleTable" id="device-list" :data="info.list" :height="tableHeight"
                          :row-class-name="tableRowClassName"
                          :header-cell-style="{backgroundColor: '#efefef'}" size="mini" @row-click="checkRow"
                          style="width:99%" @selection-change="handleSelectionChange">
                    <el-table-column align="center" header-align="center" type="selection"
                                     :selectable="canSelect"></el-table-column>
                    <el-table-column prop="id" label="ID" min-width="50px">
                        <template slot-scope="scope">
                            {{scope.row.cardType === 1 ? scope.row.id : "分层"}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="caseNo" label="机箱号">
                    </el-table-column>
                    <el-table-column label="槽位号">
                        <template slot-scope="scope">
                            <div class="card-pos">
                                <span style="width:30px;text-align: left">{{scope.row.slotNo}}</span>
                                <block v-if="systemType == 1">
                                    <el-button type="text" size="small" slot="reference" :disabled="true"
                                               v-if="scope.row.isContainer == 1"
                                               @click.stop="showCasePos(scope.row)"><img
                                            style="width:20px; height: 20px;" src="../assets/magnifier_gray.png"/>
                                    </el-button>
                                    <el-button type="text" size="small" slot="reference" v-else
                                               @click.stop="showCasePos(scope.row)"><img
                                            style="width:20px; height: 20px;" src="../assets/magnifier.png"/>
                                    </el-button>
                                </block>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
                    <el-table-column label="设备版本">
                        <template slot-scope="scope">
                            <el-tooltip effect="light" placement="top">
                                <span slot="content">{{scope.row.version}}</span>
                                <span style="max-width: 120px;overflow: hidden; white-space: nowrap;text-overflow: ellipsis;">{{scope.row.version}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="分组">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" slot="reference"
                                       @click.stop="goGroupDev(scope.row.groupName)">{{scope.row.groupName}}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="disk" label="故障时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.faultTime | formatDateTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120px" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click.stop="showFaultRecord(scope.row)">查看故障记录
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="list-bottom" @click.stop="">
                    <div class="list-bottom-btn">
                    </div>
                    <el-pagination
                            @size-change="sizeChangeHandle"
                            @current-change="currentChangeHandle"
                            :current-page="page.startPage"
                            :page-sizes="[10, 20, 50]"
                            :page-size="page.limit"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next"
                            :total="info.total">
                    </el-pagination>
                </div>

                <el-drawer
                        title="查看故障记录"
                        :visible.sync="faultRecordShow"
                        :append-to-body="true"
                        size="350px"
                        direction="rtl">
                    <div class="fault-device-info">
                        <span>云机ID：{{faultDeviceRecord.id}}</span>
                        <span>机箱号：{{faultDeviceRecord.caseNo}}</span>
                        <span>槽位号：{{faultDeviceRecord.slotNo}}</span>

                        <span>云机IP：{{faultDeviceRecord.deviceIp}}</span>
                        <span>引擎版本：{{faultDeviceRecord.version}}</span>
                        <div style="width: 100%; height: 1px; background-color:#aaa;margin-top: 10px;margin-bottom: 10px;"></div>
                        <span style="color: #333;font-weight: bold">总故障次数：{{faultRecords.total}}</span>
                        <div class="records-list-box">
                            <div v-for="record in faultRecords.list" class="one-fault-record">
                                <span style="margin-right: 80px;">{{record.updateTime | formatDateTime}}</span>
                                <span :style="{color:record.logType == 1 ? 'red': 'green' }">{{record.logType == 1 ? '发生故障' : '恢复正常'}}</span>
                            </div>
                        </div>
                    </div>

                </el-drawer>
                <el-drawer
                        title="连通性测试结果"
                        :visible.sync="devicePingPopShow"
                        :append-to-body="true"
                        size="300px"
                        direction="rtl">
                    <div style="height: 100%;display: flex;flex-direction: column;border-top: thin solid #ddd;"
                         v-if="devicePingList.length > 0">
                        <div style="flex-grow: 1;padding: 20px;overflow: auto;height: 600px;padding-bottom: 100px;">
                            <div v-for="item in devicePingList" style="margin-top: 8px;">
                                <span style="font-size: 16px;">{{item.deviceIp}}</span>
                                <span :style="{color: item.isSuccess ? 'green' : 'red', marginLeft: '20px', fontSize: '14px'}">{{item.isSuccess | detailIntToString}}</span>
                            </div>
                        </div>
                        <div style="position: fixed;bottom: 0;padding: 10px 20px;border-top: thin solid #ddd;width: 100%;background-color: white;z-index: 200">
                            <el-button size="mini" type="primary" @click="exportDevicePing">导出结果</el-button>
                        </div>
                    </div>
                    <div style="height: 100%;display: flex;flex-direction: column;align-items: center; justify-content: center;border-top: thin solid #ddd;"
                         v-else>
                        <div style="font-size: 16px; color: #333;">正在测试，请稍候...</div>
                    </div>
                </el-drawer>

                <Drawer title="跨板重启" :visible.sync="unListDevCrossRebootShow" @handClick="rebootCrossUnListDev">
                    <el-form label-width="80px"
                             label-position="left">
                        <el-form-item size="mini" label="引擎版本" :required="true">
                            <div class="item-input">
                                <el-select v-model="crossRebootExtraInfo.engineType" size="mini" placeholder="请选择"
                                           style="width: 180px">
                                    <el-option
                                            v-for="item in searchOptions.version"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item size="mini" label="槽位号" :required="true">
                            <el-input v-model="crossRebootExtraInfo.slotNo" style="width: 180px" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="设备IP" :required="true">
                            <el-input v-model="crossRebootExtraInfo.deviceIp" style="width: 180px"
                                      size="mini"></el-input>
                        </el-form-item>
                    </el-form>
                </Drawer>
            </div>
        </div>
        <DeviceCase3D ref="case3d"  v-if="casePosShow">

        </DeviceCase3D>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import DeviceCase3D from '@/components/DeviceCase3D'

    export default {
        name: "FaultDeviceList",
        components: {
            Drawer, DeviceCase3D
        },
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        }]
                },
                dateValue: [new Date(new Date() - 3600 * 1000 * 24 * 3), new Date()],
                unListDevCrossRebootShow: false,
                crossRebootExtraInfo: {
                    engineType: "",
                    deviceIp: "",
                    slotNo: ""
                },

                tableHeight: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                devicePingList: [],
                multipleSelection: [], // 选中的对象列表
                groupDevPopShow: false, // 是否显示分组弹窗
                faultDeviceRecord: '', //查看故障记录的设备
                faultRecordShow: false,//显示故障记录
                faultRecords: {
                    total: 0,
                    list: []
                },
                formLabelWidth: '120px',
                groupInfo: {
                    groupId: '',
                    deviceIp: ''
                },
                groupList: [],
                options: [],
                caseOptions: [],
                advancedShow: false,
                devicePingPopShow: false,
                searchInfo: {
                    deviceIp: "",
                    caseNo: "",
                    engineType: "",
                    groupId: "",
                    deviceNo: "",
                },
                defaultSearchInfo: {
                    deviceIp: "",
                    caseNo: "",
                    engineType: "",
                    groupId: "",
                    deviceNo: "",
                },
                searchOptions: {
                    version: []
                },
                timeoutId: 0,
                systemType: 1,
                casePosShow: false
            }
        },

        computed: {},
        methods: {
            showCasePos(row) {
                if (this.$refs.case3d) {
                    this.$refs.case3d.showCasePos(row)
                }
            },
            // hideAllPopShow() {
            //     if (this.$refs.case3d) {
            //         this.$refs.case3d.hideAllPopShow()
            //     }
            // },
            showFaultRecord(row) {
                // console.log("row ", row)
                this.faultDeviceRecord = JSON.parse(JSON.stringify(row))
                this.getFaultRecordsList(row.deviceIp)
                // console.log("faultDeviceRecord ", faultDeviceRecord)
                this.faultRecordShow = true
            },
            startDevicePing() {
                if (this.multipleSelection.length === 0) {
                    this.$confirm("请勾选要测试连通性的云机", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    let deviceIps = []
                    this.devicePingList = []
                    this.devicePingPopShow = true
                    this.multipleSelection.forEach(v => {
                        deviceIps.push(v.deviceIp)
                    })

                    this.$post(this.$uri.device.devicePing, {deviceIps}).then(res => {
                        if (res.success) {
                            this.devicePingList = res.list
                            // console.log("devicePingList " + JSON.stringify(this.devicePingList))
                        } else {
                            this.$message.error("测试失败")
                        }
                    })
                }
            },

            exportDevicePing() {
                let txtStr = ""
                this.devicePingList.forEach(item => {
                    let deviceResult = item.deviceIp + " "
                    if (item.isSuccess) {
                        deviceResult += "成功"
                    } else {
                        deviceResult += "失败"
                    }
                    deviceResult += "\n"
                    txtStr += deviceResult
                })
                // console.log("txtStr " + txtStr)
                let str = new Blob([txtStr], {type: 'text/plain;charset=utf-8'});
                saveAs(str, `连通性测试结果.txt`);
            },
            /* 跳转组内设备 */
            goGroupDev(groupName) {
                // console.log("groupName is ", groupName)
                if (groupName.length > 0) {
                    let groupInfo = null
                    this.groupList.forEach(item => {
                        if (item.groupName === groupName) {
                            groupInfo = item
                            return
                        }
                    })
                    if (groupInfo) {
                        this.$store.commit(this.$mutation.GROUP_DETAIL, groupInfo)
                        this.$router.push("/home/group/dev")
                    }
                }
            },
            rebootCrossUnListDev() {
                // console.log("this.crossRebootExtraInfo.engineType " + this.crossRebootExtraInfo.engineType)
                if (this.crossRebootExtraInfo.engineType.length === 0) {
                    this.$confirm("请选择引擎版本", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                }
                else if (this.crossRebootExtraInfo.slotNo.length === 0) {
                    this.$confirm("请输入槽位号", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                }
                else if (this.crossRebootExtraInfo.deviceIp.length === 0) {
                    this.$confirm("请输入设备IP", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    this.$post(this.$uri.device.rebootCross, {...this.crossRebootExtraInfo}).then(res => {
                        if (res.success) {
                            this.$message.success("跨板重启完成")
                        }
                    }).finally(() => {
                        this.unListDevCrossRebootShow = false
                    })
                }
            },

            /* 表单击行事件 */
            checkRow(r, c, e) {
                if (r.cardType === 1 && (!this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || r.deviceUuid.length == 0 || r.isAuth === 1)) this.$refs.multipleTable.toggleRowSelection(r)
            },

            /* 获取故障设备列表 */
            getFaultDeviceList() {
                // console.log("dateValue is ", this.dateValue)
                if (!this.dateValue) {
                    this.dateValue = []
                }
                if (this.dateValue.length > 0) {
                    this.searchInfo.faultTimeFrom = this.$util.formatDate(this.dateValue[0])
                    this.searchInfo.faultTimeTo = this.$util.formatDate(this.dateValue[1])
                }
                else {
                    this.searchInfo.faultTimeFrom = ""
                    this.searchInfo.faultTimeTo = ""
                }

                this.$post(this.$uri.device.deviceList, {
                    ...this.page, ...this.searchInfo,
                    deviceStatus: 3
                }).then(res => {
                    if (res.success) {
                        this.info = res
                        this.$nextTick().then(() => {
                            if (this.$refs.multipleTable) {
                                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                                if (this.casePosShow == false) {
                                    this.casePosShow = true
                                }
                            }
                        })
                    }
                    // console.log("faultDeviceList res " + JSON.stringify(res))
                })
            },
            getFaultDeviceListForSearch() {
                this.page.startPage = 1
                if (!this.dateValue) {
                    this.dateValue = []
                }
                if (this.dateValue.length > 0) {
                    this.searchInfo.faultTimeFrom = this.$util.formatDate(this.dateValue[0])
                    this.searchInfo.faultTimeTo = this.$util.formatDate(this.dateValue[1])
                }
                else {
                    this.searchInfo.faultTimeFrom = ""
                    this.searchInfo.faultTimeTo = ""
                }
                this.$post(this.$uri.device.deviceList, {
                    ...this.page, ...this.searchInfo,
                    deviceStatus: 3
                }).then(res => {
                    this.info = res
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                    // console.log("faultDeviceList res " + JSON.stringify(res))
                })
            },
            //获取故障设备的故障记录
            getFaultRecordsList(deviceIp) {
                this.$post(this.$uri.log.deviceLog, {deviceIp}).then(res => {
                    this.faultRecords = res
                })
            },
            cleanSearchInfo() {
                this.searchInfo = JSON.parse(JSON.stringify(this.defaultSearchInfo))
                // console.log("searchInfo is " + JSON.stringify(this.searchInfo))
                this.getFaultDeviceListForSearch()
            },

            checkLicenseService(index) {
                let found = -1
                if (this.$store.state.licenseInfo && this.$store.state.licenseInfo) {
                    let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
                    serviceItems.forEach(item => {
                        // console.log("item is " + item + ", index is " + index)
                        if (item == index) {
                            found = 1
                            return
                        }
                    })
                }
                return found
            },

            canSelect(row, index) {
                return !this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || row.deviceUuid.length === 0 || row.isAuth === 1
            },

            tableRowClassName({row, index}) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return 'not-auth-color';
                }
                return ''
            },

            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getFaultDeviceList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getFaultDeviceList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },

            selectIpsHasMirrorOps() {
                let mirrorOps = false
                this.multipleSelection.forEach(dev => {
                    if (dev.deviceMirrorOperationStatus != null && dev.deviceMirrorOperationStatus != 5 && dev.deviceMirrorOperationStatus != 14) {
                        // console.log("dev is " + JSON.stringify(dev))
                        mirrorOps = true
                        return
                    }
                });

                return mirrorOps;
            },

            /* 设备批量跨板重启 */
            rebootDevCross() {
                if (this.multipleSelection.length === 0) {
                    this.unListDevCrossRebootShow = true
                } else {
                    let hasMirrorOps = this.selectIpsHasMirrorOps()
                    if (hasMirrorOps) {
                        this.$confirm("所选云机正在进行镜像操作，不能重启", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            }).catch(() => {
                        })
                    } else {
                        this.$confirm("跨板重启针对同一设备，每5分钟仅可执行一次，是否继续？", "提示", {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'confirm-btn-yellow',
                            iconClass: 'el-icon-c-yellow',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let deviceIps = []
                            this.multipleSelection.forEach(v => {
                                deviceIps.push(v.deviceIp)
                            })
                            this.$post(this.$uri.device.deviceReboot, {deviceIps, isCross: 1}).then(res => {
                                this.$message.success("重启完成")
                                this.getFaultDeviceList()
                            })
                        }).catch(() => {
                        })
                    }
                }
            },

            /* 获得分组信息 */
            getGroupList() {
                this.$post(this.$uri.group.list, {}).then(res => {
                    let options = []
                    this.groupList = res.list
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.groupName
                        })
                    })
                    this.options = options
                })
            },
            /* 获得设备池信息 */
            getDevGroupList() {
                this.$post(this.$uri.device.caseList, {}).then(res => {
                    let options = []
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.caseNo
                        })
                    })
                    this.caseOptions = options
                })
            },

            /* 获取所有引擎版本信息 */
            getEngineVersion() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    let list = []

                    res.list.forEach(v => {
                        list.push({
                            label: v.content,
                            value: v.code
                        })
                    })
                    this.searchOptions.version = list
                })
            },
            getDeviceType() {
                this.$post(this.$uri.system.paramGet, {paramName: "systemType"}).then(res => {
                    console.log("getDeviceType " + JSON.stringify(res))
                    if (res.success) {
                        this.systemType = parseInt(res.data.paramValue)
                    }
                })
            },
        },
        filters: {
            detailIntToString(value) {
                // console.log("value is " + value)
                switch (value) {
                    case true:
                        return "成功"
                    case false:
                        return "失败"

                    default:
                        return ""
                }
            },
            devCodeStr(row) {
                if (row.isContainer === 1) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "容器-ry-" + row.deviceNo
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "容器-gt-" + row.deviceNo
                    } else {
                        return "容器-ot-" + row.deviceNo
                    }
                }
                else if (row.isContainer === 0) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "宿主机-ry-" + row.deviceNo
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "宿主机-gt-" + row.deviceNo
                    } else {
                        return "宿主机-ot-" + row.deviceNo
                    }
                }
            },

        },
        mounted() {
            this.getDeviceType()
            this.getFaultDeviceList()
            this.getDevGroupList()
            this.getGroupList()
            this.getEngineVersion()
            this.$store.commit(this.$mutation.DISPLAY_MODE, 1)

        },
        destroyed() {

        }
    };
</script>

<style lang="less">
    .dev-list {
        z-index: 1;
        width: 100%;
        background-color: white;
        /*height: 100vh;*/
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                border: 1px solid #efefef;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .search-main-item {
                        margin-right: 8%;
                        width: 24%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                            width: 100px;
                        }
                        .item-input {
                            /*margin-left: 30px;*/
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 20px 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;

                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }

    .not-auth-color {
        color: #aaa;
    }

    .fault-device-info {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-top: thin solid #ddd;
        color: #333;
        padding: 10px;
        span {
            margin-bottom: 8px;
            font-size: 14px;
        }
        .records-list-box {
            width: 300px;
            height: 580px;
            padding: 10px;
            border: 1px solid #bbb;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            /*background-color: red;*/
            .one-fault-record {
                padding-bottom: 10px;
            }
        }
    }

    .card-pos {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
</style>
